<template>
  <div>
    <CardedForm
      ref="admin_adverts_form_ref"
      id="admin_adverts_form"
      title="_"
      :is_loading="is_loading"
      @on-submit-form="upload_advert_image"
      :errors="errors"
      :message="message"
      @on-auto-fill="on_auto_fill"
      @on-close-message="on_hide_message"
    >
      <TextField
        v-model="form.title"
        :validation_rules="form_validations.title"
        label="Advert Title"
        icon="mdi-pen-plus"
        :disabled="is_loading"
      ></TextField>
      <v-row no-gutterss class="pa-0 mb-0">
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <TextField
            v-model="form.width_pixels"
            :validation_rules="form_validations.width_pixels"
            label="Width (in pixels)"
            icon="mdi-pen-plus"
            :disabled="is_loading"
          ></TextField>
        </v-col>
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <TextField
            v-model="form.height_pixels"
            :validation_rules="form_validations.height_pixels"
            label="Height (in pixels)"
            icon="mdi-pen-plus"
            :disabled="is_loading"
          ></TextField>
        </v-col>
      </v-row>

      <TextField
        v-model="form.navigation_url"
        :validation_rules="form_validations.navigation_url"
        label="Navigation URL"
        icon="mdi-pen-plus"
        :disabled="is_loading"
      ></TextField>
      <v-row no-gutterss class="pa-0 mb-0">
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <TextField
            v-model="form.media_type"
            :validation_rules="[]"
            label="Media Type"
            icon="mdi-pen-plus"
            :disabled="true"
          ></TextField>
        </v-col>
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <SelectField
            v-model="form.platform"
            :options="platforms"
            :small_chips="false"
            :validation_rules="form_validations.platform"
            label="Select Target Platform"
            icon="mdi-pen-plus"
            :disabled="is_loading"
            item_text="label"
            item_value="name"
          ></SelectField>
        </v-col>
      </v-row>
      <v-row no-gutterss class="pa-0 mb-0">
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <SelectField
            v-model="form.page"
            :options="pages"
            :small_chips="false"
            :validation_rules="form_validations.page"
            label="Select Target Page"
            icon="mdi-pen-plus"
            :disabled="is_loading"
            item_text="label"
            item_value="name"
          ></SelectField>
        </v-col>
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <SelectField
            v-model="form.section"
            :options="sections"
            :small_chips="false"
            :validation_rules="form_validations.section"
            label="Select Target Page Section"
            icon="mdi-pen-plus"
            :disabled="is_loading"
            item_text="label"
            item_value="name"
          ></SelectField>
        </v-col>
      </v-row>
      <ImageField
        label="Advert Image"
        icon="mdi-camera"
        :disabled="is_loading"
        folder="adverts"
        @on-hide-loader="hide_loader"
        @on-show-loader="show_loader"
        @on-success="on_finished_advert_image_upload"
        @on-error="on_advert_image_upload_errors"
        ref="advert_image_uploader"
        :required="!is_editing"
        empty_file_error="Please Select An Advert Image"
        :default_value="form.media_url"
        :messages="advert_image_messages"
      >
      </ImageField>
    </CardedForm>
  </div>
</template>

<script>
import CardedForm from "../../../components/CardedForm";
import ImageField from "../../../components/ImageField";
import TextField from "../../../components/TextField";
import SelectField from "../../../components/SelectField";
import ServerClient from "../../../lib/ServerClient";
import page_info from "../../../lib/page_info";
import Utils from "../../../lib/Utils";
export default {
  name: "AdminAdvertsAdd",
  components: {
    CardedForm,
    TextField,
    SelectField,
    ImageField,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    is_editing: {
      type: Boolean,
      default: false,
    },
    advert_editing: {
      type: Object,
      default: () => {
        return Utils.get_default_advert();
      },
    },
  },
  data: () => {
    return {
      errors: [],
      message: "",
      form: {
        title: "",
        navigation_url: "",
        media_type: "image",
        platform: "",
        page: "",
        section: "",
        media_url: "",
        width_pixels: 0,
        height_pixels: 0
      },
      form_validations: {
        title: [
          Utils.validate.is_required("Advert title is required"),
          Utils.validate.min_max_length(
            10,
            50,
            "Advert title has to be between 10 and 50 characters long"
          ),
        ],
        navigation_url: [
          Utils.validate.is_required("Advert's click url is required"),
          Utils.validate.min_max_length(
            10,
            300,
            "Advert's click url has to be between 10 and 300 characters long"
          ),
        ],
        media_type: [
          Utils.validate.is_required("Media type is required"),
          Utils.validate.min_max_length(
            10,
            20,
            "Media type has to be between 10 and 20 characters long"
          ),
        ],
        platform: [
          Utils.validate.is_required("Target Platform is required"),
          Utils.validate.min_max_length(
            3,
            300,
            "Platform has to be between 3 and 300 characters long"
          ),
        ],
        page: [
          Utils.validate.is_required("Target Page is required"),
          Utils.validate.min_max_length(
            3,
            300,
            "Page has to be between 3 and 300 characters long"
          ),
        ],
        section: [
          Utils.validate.is_required("Section is required"),
          Utils.validate.min_max_length(
            3,
            300,
            "Section has to be between 3 and 300 characters long"
          ),
        ],
        width_pixels: [
          Utils.validate.is_required("Specify the advert image width in pixels"),
          Utils.validate.numeric("Width must be a whole number"),
          Utils.validate.min_max(100,600, "Width must be between 100 and 600 pixels"),
        ],
        height_pixels: [
          Utils.validate.is_required("Specify the advert image height in pixels"),
          Utils.validate.numeric("Height must be a whole number"),
          Utils.validate.min_max(100,600, "Height must be between 100 and 600 pixels"),
        ]
      },
      platforms: page_info.ad_platforms,
      advert_image_messages: [],
    };
  },
  methods: {
    on_auto_fill() {
      var rnd = Math.ceil(Math.random() * 9493);
      this.form.title = "Cool Advert " + rnd;
      this.form.navigation_url = "https://www.mycooladvert" + rnd + ".com";
      this.form.media_type = "image";
      this.form.platform = "";
      this.form.page = "";
      this.form.section = "";
      this.form.media_url = "";
      this.form.width_pixels = 240;
      this.form.height_pixels = 250;

      if (this.platforms.length > 0) {
        this.form.platform = this.platforms[0].name;
        if (this.platforms[0].pages.length > 0) {
          this.form.page = this.platforms[0].pages[0].name;
          if (this.platforms[0].pages[0].sections.length > 0) {
            this.form.section = this.platforms[0].pages[0].sections[0].name;
          }
        }
      }

      this.advert_image_messages = [];
      this.errors = [];
      this.message = "";
      this.$refs.admin_adverts_form_ref.on_clear_validations();
    },
    init_form() {
      if (this.is_editing == true) {
        this.form.title = this.advert_editing.title;
        this.form.navigation_url = this.advert_editing.navigation_url;
        this.form.media_type = this.advert_editing.media_type;
        this.form.platform = this.advert_editing.platform;
        this.form.page = this.advert_editing.page;
        this.form.section = this.advert_editing.section;
        this.form.media_url = this.advert_editing.media_url;
        this.form.width_pixels = this.advert_editing.width_pixels;
        this.form.height_pixels = this.advert_editing.height_pixels;
      } else {
        this.form.title = "";
        this.form.navigation_url = "";
        this.form.media_type = "image";
        this.form.platform = "";
        this.form.page = "";
        this.form.section = "";
        this.form.media_url = "";
        this.form.width_pixels = 0;
        this.form.height_pixels = 0;
      }
      this.advert_image_messages = [];
      this.errors = [];
      this.message = "";
      this.$refs.admin_adverts_form_ref.on_clear_validations();
    },
    hide_loader() {
      this.$emit("on-hide-loader");
    },
    show_loader() {
      this.$emit("on-show-loader");
    },
    upload_advert_image() {
      this.$refs.advert_image_uploader.upload_file();
    },
    on_finished_advert_image_upload(file_url) {
      this.form.media_url = file_url;
      if(this.is_editing == true){
        this.update_advert();
      }else{
        this.submit();
      }
    },
    on_advert_image_upload_errors(errors) {
      this.errors = errors;
      this.$refs.admin_adverts_form_ref.show_error_dialog();
    },
    submit() {
      this.errors = [];
      this.message = "";
      this.show_loader();
      ServerClient.Adverts.post_advert(
        {
          ...this.form,
        },
        (res) => {
          this.hide_loader();
          this.message =
            "<b>Operation was successfull</b> <br/>  New advert was added successfully";
          this.$refs.admin_adverts_form_ref.show_message_dialog();
        },
        (errors) => {
          this.hide_loader();
          this.errors = errors;
          this.$refs.admin_adverts_form_ref.show_error_dialog();
        }
      );
    },
    update_advert(){
      this.errors = [];
      this.message = "";
      this.show_loader();
      ServerClient.Adverts.update_advert(
        {
          data: {
            ...this.form
          },
          id: this.advert_editing.id
        },
        (res) => {
          this.hide_loader();
          this.message =
            "<b>Operation was successfull</b> <br/>  The advert was updated successfully";
          this.$refs.admin_adverts_form_ref.show_message_dialog();
        },
        (errors) => {
          this.hide_loader();
          this.errors = errors;
          this.$refs.admin_adverts_form_ref.show_error_dialog();
        }
      );
    },
    on_hide_message() {
      if(this.is_editing == true){
        this.$emit('on-success-edit-advert');
      }else{
        this.init_form();
      }
    },
  },
  computed: {
    pages() {
      var lst = [];
      for (let index = 0; index < this.platforms.length; index++) {
        var platform = this.platforms[index];
        if (platform.name == this.form.platform) {
          lst = platform.pages;
        }
      }
      return lst;
    },
    sections() {
      var lst = [];
      for (let index = 0; index < this.pages.length; index++) {
        var page = this.pages[index];
        if (page.name == this.form.page) {
          lst = page.sections;
        }
      }
      return lst;
    },
  },
  mounted() {
    this.$emit("set-page-attributes", {
      title: "Add a New Adverts",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Adverts",
          disabled: false,
          href: "/admin/adverts",
        },
        {
          text: "New",
          disabled: true,
          href: "/admin/adverts/add",
        },
      ],
    });
    this.init_form();
  },
};
</script>